import {AccentColorOptions} from 'epic-ue-theme/src/types/colors.types';
import React from 'react';
import styled from 'styled-components';
import {DownloadSection, DownloadSectionProps} from '../section/download/DownloadSection';
import {NewsletterSection, NewsletterSectionProps} from '../section/newsletter/NewsletterSection';

const FooterBuffer = styled.div<{$footerColor?: string; $height: number}>`
    width: 100%;
    height: ${(p) => p.$height - 56}px; /* footer has 56 of top padding */
    background-color: ${(p) => p.$footerColor || p.theme.palette.neutral.carbon};
    ${(p) => p.theme.breakpoints.down('sm')} {
        height: 0;
    }
`;

const DownloadVideoNewsletterWrap = styled.div<{
    $downloadPadding: number;
    accentColor: AccentColorOptions;
}>`
    position: relative;

    .video.ue-download-section {
        ${(p) => p.theme.breakpoints.up('md')} {
            padding-bottom: ${(p) => p.$downloadPadding}px;
        }
    }

    .ue-newsletter-section {
        ${(p) => p.theme.breakpoints.up('md')} {
            position: absolute;
            margin: 0 auto;
            left: 0;
            right: 0;
            bottom: 0;
            transform: translateY(50%);
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            .ue-grid-container {
                padding: 0;
            }
        }

        .ue-link-wrap {
            color: ${(p) => p.theme.palette.accent.dark[p.accentColor]};
        }
    }
`;

export interface DownloadVideoAndNewsletterSplitProps {
    download?: DownloadSectionProps;
    downloadSectionVariant?: 'gradient' | 'standard' | 'video';
    newsletter?: NewsletterSectionProps;
    staticIndustry?: string;
    footerColor?: string;
    accentColor?: AccentColorOptions;
}

export const DownloadVideoAndNewsletterSplit = (
    props: DownloadVideoAndNewsletterSplitProps
): JSX.Element => {
    const newsletter = props?.newsletter;
    const newsVariant = newsletter?.variant;
    let newsHeight = 422;
    if (newsVariant && newsVariant.indexOf('small') > -1) {
        newsHeight = 96;
    }
    const padding = newsHeight / 2 + 128;

    return (
        <>
            <DownloadVideoNewsletterWrap
                $downloadPadding={padding}
                accentColor={props.accentColor || 'sky'}>
                <DownloadSection
                    {...props?.download}
                    variant={props.downloadSectionVariant}
                    accentColor={props.accentColor}
                />
                <NewsletterSection
                    {...props?.newsletter}
                    staticIndustry={props.staticIndustry}
                    accentColor={props.accentColor}
                />
            </DownloadVideoNewsletterWrap>
            <FooterBuffer $footerColor={props.footerColor} $height={padding} />
        </>
    );
};
